import {CustomNoDataOverlay} from "@/styles/components/data-grid";
import {Face} from "@mui/icons-material";
import {Avatar, Box, Typography} from "@mui/material";
import {DataGrid, GridColDef, GridValueFormatterParams} from '@mui/x-data-grid';
import {GridRenderCellParams} from "@mui/x-data-grid/models/params/gridCellParams";
import React from "react";

interface TableRow {
	name: string;
	image_url: string;
	penetration: number;
	index: number;
	growth: number;
}


interface StarTableProps {
	title: string;
	rows: TableRow[];
}

export const StarTable: React.FC<StarTableProps> = (
	{
		title,
		rows
	}) => {

	const renderStar = (params: GridRenderCellParams) => {
		return (
			<Box display="flex" flexDirection="row" alignItems="center">
				<Avatar src={params.value.image} alt="star" sx={{width: 30, height: 30}}><Face/></Avatar>
				<Typography ml={2}>{params.value.name}</Typography>
			</Box>
		)
	}

	const columns: GridColDef[] = [
		{
			field: 'name',
			headerName: 'Name',
			flex: 3,
			sortable: false,
			disableColumnMenu: true,
			valueGetter: (params) => {
				return {'name': params.row.name, 'image': params.row.image_url}
			},
			renderCell: renderStar
		},
		{
			field: 'penetration',
			headerName: 'Reach',
			disableColumnMenu: true,
			flex: 1,
			valueFormatter: (params:GridValueFormatterParams<number> ) => {
				return `${(params.value * 100).toFixed(1)}%`
			}
		},
		{
			field: 'index',
			headerName: 'Affinity',
			disableColumnMenu: true,
			flex: 1,
			valueFormatter: (params:GridValueFormatterParams<number> ) => {
				return `${params.value.toFixed(1)}`
			}
		},
		{
			field: 'growth',
			headerName: 'Growth',
			disableColumnMenu: true,
			flex: 1,
			valueFormatter: (params:GridValueFormatterParams<number> ) => {
				return `${(params.value * 100).toFixed(1)}%`
			}
		},
	];

	return (
		<>
			<Typography variant="h6" mb={2}>{title}</Typography>
			<Box height={500}>
				<DataGrid
					columns={columns}
					rows={rows}
					slots={{
						noRowsOverlay: () => (
							<CustomNoDataOverlay text="No audiences found"/>
						)
					}}
					hideFooterPagination
					hideFooter
					disableRowSelectionOnClick
				/>
			</Box>
		</>
	);
}
